<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="toc_page"></a>
<a id="page_ix"></a>
<h2 class="title1">Contents</h2>
<p class="toc-front" id="toc_p1">
<a href="#/intro">Introduction: Lyric Substance and Social Being</a>
</p>
<p class="toc-chapter" id="toc_p2">
<a href="#/chap1">1    The Spectacle of Obscurity</a>
</p>
<p class="toc-h1" id="toc_p3">
<a href="#/chap1#chap1_p11">
<i>In the Vernacular</i>
</a>
</p>
<p class="toc-h1" id="toc_p4">
<a href="#/chap1#chap1_p24">
<i>Anon</i>
</a>
</p>
<p class="toc-h1" id="toc_p5">
<a href="#/chap1#chap1_p28">
<i>Kryptonite</i>
</a>
</p>
<p class="toc-h1" id="toc_p6">
<a href="#/chap1#chap1_p37">
<i>Def Rhapsody</i>
</a>
</p>
<p class="toc-h1" id="toc_p7">
<a href="#/chap1#chap1_p49">
<i>Thick as Thieves</i>
</a>
</p>
<p class="toc-h1" id="toc_p8">
<a href="#/chap1#chap1_p65">
<i>The Riddle of Being</i>
</a>
</p>
<p class="toc-chapter" id="toc_p9">
<span href="#/chap2" title="Link target outside of Sample">2    Riddlecraft</span>
</p>
<p class="toc-h1" id="toc_p10">
<span href="#/chap2#chap2_p6" title="Link target outside of Sample">
<i>In the Parlance of Things</i>
</span>
</p>
<p class="toc-h1" id="toc_p11">
<span href="#/chap2#chap2_p37" title="Link target outside of Sample">
<i>Black Wonder</i>
</span>
</p>
<p class="toc-h1" id="toc_p12">
<span href="#/chap2#chap2_p47" title="Link target outside of Sample">
<i>Orpheus and the Backwardness of Things</i>
</span>
</p>
<p class="toc-h1" id="toc_p13">
<span href="#/chap2#chap2_p54" title="Link target outside of Sample">
<i>Darkness Visible</i>
</span>
</p>
<p class="toc-h1" id="toc_p14">
<span href="#/chap2#chap2_p59" title="Link target outside of Sample">
<i>The Metaphysics of Dust</i>
</span>
</p>
<p class="toc-h1" id="toc_p15">
<span href="#/chap2#chap2_p109" title="Link target outside of Sample">
<i>Counterfeit Gloom</i>
</span>
</p>
<p class="toc-chapter" id="toc_p16">
<span href="#/chap3" title="Link target outside of Sample">3    Lost Laboratories of the Sphinx</span>
</p>
<p class="toc-h1" id="toc_p17">
<span href="#/chap3#chap3_p2" title="Link target outside of Sample">
<i>Enigmatography</i>
</span>
</p>
<p class="toc-h1" id="toc_p18">
<span href="#/chap3#chap3_p10" title="Link target outside of Sample">
<i>Rhapsodic Measures</i>
</span>
</p>
<p class="toc-h1" id="toc_p19">
<span href="#/chap3#chap3_p29" title="Link target outside of Sample">
<i>Hex</i>
</span>
</p>
<p class="toc-h1" id="toc_p20">
<span href="#/chap3#chap3_p35" title="Link target outside of Sample">
<i>Ransom in a Voice</i>
</span>
</p>
<p class="toc-h1" id="toc_p21">
<span href="#/chap3#chap3_p112" title="Link target outside of Sample">
<i>Elegiac Questions</i>
</span>
</p>
<p class="toc-h1" id="toc_p22">
<span href="#/chap3#chap3_p117" title="Link target outside of Sample">
<i>Fetters, Jinx, Logic</i>
</span>
</p>
<p class="toc-h1" id="toc_p23">
<span href="#/chap3#chap3_p127" title="Link target outside of Sample">
<i>Blow-Up</i>
</span>
</p>
<a id="page_x"></a>
<p class="toc-chapter" id="toc_p24">
<span href="#/chap4" title="Link target outside of Sample">4    Lyric Monadologies</span>
</p>
<p class="toc-h1" id="toc_p25">
<span href="#/chap4#chap4_p4" title="Link target outside of Sample">
<i>Genetic Obscurity</i>
</span>
</p>
<p class="toc-h1" id="toc_p26">
<span href="#/chap4#chap4_p20" title="Link target outside of Sample">
<i>Ariadne’s Thread</i>
</span>
</p>
<p class="toc-h1" id="toc_p27">
<span href="#/chap4#chap4_p29" title="Link target outside of Sample">
<i>The Infinity of Small, Hidden Springs</i>
</span>
</p>
<p class="toc-h1" id="toc_p28">
<span href="#/chap4#chap4_p38" title="Link target outside of Sample">
<i>Lucifer’s Element, or the Secrets of the Sublime</i>
</span>
</p>
<p class="toc-h1" id="toc_p29">
<span href="#/chap4#chap4_p67" title="Link target outside of Sample">
<i>Logic, Expression, Harmony</i>
</span>
</p>
<p class="toc-h1" id="toc_p30">
<span href="#/chap4#chap4_p84" title="Link target outside of Sample">
<i>Clockwork of the Infidel</i>
</span>
</p>
<p class="toc-h1" id="toc_p31">
<span href="#/chap4#chap4_p91" title="Link target outside of Sample">
<i>Infinity, Inc.</i>
</span>
</p>
<p class="toc-h1" id="toc_p32">
<span href="#/chap4#chap4_p95" title="Link target outside of Sample">
<i>Sleeper Cells and Slumbering Monads</i>
</span>
</p>
<p class="toc-chapter" id="toc_p33">
<span href="#/chap5" title="Link target outside of Sample">5    Infidel Lyric: The Rhymes of the Canting Crew</span>
</p>
<p class="toc-h1" id="toc_p34">
<span href="#/chap5#chap5_p15" title="Link target outside of Sample">
<i>Flash, etc.</i>
</span>
</p>
<p class="toc-h1" id="toc_p35">
<span href="#/chap5#chap5_p38" title="Link target outside of Sample">
<i>Strange Navigation</i>
</span>
</p>
<p class="toc-h1" id="toc_p36">
<span href="#/chap5#chap5_p45" title="Link target outside of Sample">
<i>Sparrow Language</i>
</span>
</p>
<p class="toc-h1" id="toc_p37">
<span href="#/chap5#chap5_p52" title="Link target outside of Sample">
<i>The Spy’s Lexicon</i>
</span>
</p>
<p class="toc-h1" id="toc_p38">
<span href="#/chap5#chap5_p85" title="Link target outside of Sample">
<i>Ragpicker, Dandy, Apache</i>
</span>
</p>
<p class="toc-chapter" id="toc_p39">
<span href="#/chap6" title="Link target outside of Sample">6    Flash Crib: A Genealogy of Modern Nightlife</span>
</p>
<p class="toc-h1" id="toc_p40">
<span href="#/chap6#chap6_p1" title="Link target outside of Sample">
<i>The Infidel Sublime</i>
</span>
</p>
<p class="toc-h1" id="toc_p41">
<span href="#/chap6#chap6_p26" title="Link target outside of Sample">
<i>Tavern Talk</i>
</span>
</p>
<p class="toc-h1" id="toc_p42">
<span href="#/chap6#chap6_p47" title="Link target outside of Sample">
<i>The Brands of Cupid</i>
</span>
</p>
<p class="toc-h1" id="toc_p43">
<span href="#/chap6#chap6_p78" title="Link target outside of Sample">
<i>The Politics of Nightlife</i>
</span>
</p>
<p class="toc-h1" id="toc_p44">
<span href="#/chap6#chap6_p86" title="Link target outside of Sample">
<i>Infidel Culture</i>
</span>
</p>
<p class="toc-h1" id="toc_p45">
<span href="#/chap6#chap6_p144" title="Link target outside of Sample">
<i>Shoemaker-Poets</i>
</span>
</p>
<p class="toc-h1" id="toc_p46">
<span href="#/chap6#chap6_p162" title="Link target outside of Sample">
<i>Fairies and Infidels</i>
</span>
</p>
<p class="toc-h1" id="toc_p47">
<span href="#/chap6#chap6_p195" title="Link target outside of Sample">
<i>Noctambulism</i>
</span>
</p>
<p class="toc-h1" id="toc_p48">
<span href="#/chap6#chap6_p201" title="Link target outside of Sample">
<i>The Nightspot and the New Chanson</i>
</span>
</p>
<p class="toc-h1" id="toc_p49">
<span href="#/chap6#chap6_p213" title="Link target outside of Sample">
<i>Tingeltangel</i>
</span>
</p>
<p class="toc-h1" id="toc_p50">
<span href="#/chap6#chap6_p238" title="Link target outside of Sample">
<i>Smash Palace</i>
</span>
</p>
<p class="toc-h1" id="toc_p51">
<span href="#/chap6#chap6_p246" title="Link target outside of Sample">
<i>Shades of the Avant-Garde</i>
</span>
</p>
<p class="toc-chapter" id="toc_p52">
<span href="#/chap7" title="Link target outside of Sample">7    Mother Goose and Mallarmé</span>
</p>
<p class="toc-back" id="toc_p53">
<span href="#/afterword" title="Link target outside of Sample">Afterword: Social Inversion, Kitsch, and the Art of Disappearing</span>
</p>
<p class="toc-back" id="toc_p54">
<span href="#/index1" title="Link target outside of Sample">
<i>Index</i>
</span>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?83839322